import { CART_COLOUR, CART_SIZE } from '@adapters/bigcommerce/constants';
import type {
  ItemBody,
  OptionSelections,
} from '@adapters/bigcommerce/types/cart';
import type { MecProduct } from '@adapters/bigcommerce/types/product';

export interface QuickAddItemBodyInput {
  product: Pick<MecProduct, 'entityId' | 'gaName' | 'sizeOptionId'>;
  colourOptionId: number;
  variantId: number;
  colour: { id: number; name: string };
  size?: { id: number; name: string | null };
  quantity: number;
}

export const buildQuickAddItemBody = ({
  product,
  colourOptionId,
  variantId,
  colour,
  size,
  quantity,
}: QuickAddItemBodyInput): ItemBody => {
  const optionSelections: OptionSelections[] = [
    {
      option_id: colourOptionId,
      option_value: `${colour.id}`,
      name: CART_COLOUR,
      value: `${colour.name}`,
    },
    ...(product.sizeOptionId && size
      ? [
          {
            option_id: product.sizeOptionId,
            option_value: `${size.id}`,
            name: CART_SIZE,
            value: size.name ?? '',
          },
        ]
      : []),
  ];

  return {
    productName: product.gaName,
    productId: product.entityId,
    variantId,
    quantity,
    optionSelections,
  };
};

export default buildQuickAddItemBody;
